var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('LazyYoutube',{ref:"youtubeLazyVideo",attrs:{"src":"https://www.youtube.com/embed/uEhRIUjidGQ","max-width":"720px","aspect-ratio":"16:9","thumbnail-quality":"standard"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }